module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      paddingBottom: _vm.iPhoneX ? '12px' : '0'
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('Toast'), _vm._v(" "), (this.isShow) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3a6c6ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 241
// module chunks = 45